export function defaultGetItemId<T>(item: T): string | number {
  return (item as { id?: string | number }).id as string | number
}

export function createGetItemIdFromKey<T>(
  valueKey: string,
): (item: T) => string | number {
  return (item: T) =>
    (item as Record<string, string | number>)[valueKey] as string | number
}

export type OptionLabelKey =
  | string
  | ((option: unknown) => string)
  | null
  | undefined

export function getOptionLabel(
  option: unknown,
  optionLabel: OptionLabelKey,
): string {
  if (option == null) {
    return ''
  }
  if (typeof optionLabel === 'function') {
    return optionLabel(option)
  }
  if (typeof optionLabel === 'string' && typeof option === 'object') {
    return String((option as Record<string, unknown>)[optionLabel] ?? '')
  }
  return String(option)
}

export function findOptionByValue<T>(
  options: Array<T | undefined>,
  modelValue: unknown,
  getItemId: (item: T) => string | number,
): T | null {
  if (modelValue == null || modelValue === '') {
    return null
  }
  return (
    options.find((option) => {
      if (option == null) {
        return false
      }
      return getItemId(option) === modelValue
    }) ?? null
  )
}

export function isOptionSelected<T>(
  option: unknown,
  modelValue: unknown,
  getItemId: (item: T) => string | number,
): boolean {
  if (option == null || modelValue == null || modelValue === '') {
    return false
  }
  return getItemId(option as T) === modelValue
}
